import { render, staticRenderFns } from "./OrganizationsTable.vue?vue&type=template&id=1f2e6aa4&scoped=true"
import script from "./OrganizationsTable.vue?vue&type=script&lang=ts"
export * from "./OrganizationsTable.vue?vue&type=script&lang=ts"
import style0 from "./OrganizationsTable.vue?vue&type=style&index=0&id=1f2e6aa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2e6aa4",
  null
  
)

export default component.exports